import { inject } from '@angular/core';

import { SitecoreMyBetsConfig } from '@frontend/sports/common/client-config-data-access';
import { take } from 'rxjs';

import { StylesLazyLoadingService } from '../deferred/styles/style-loading.service';

export function onPreloadMyBets() {
    inject(SitecoreMyBetsConfig).whenReady.pipe(take(1)).subscribe();
    inject(StylesLazyLoadingService).lazyLoad('my-bets');
}
